module.exports = __webpack_public_path__ + "static/media/a-ending hokjønn.b931f23b.mp3";